module.exports = __webpack_public_path__ + "img/turbo_off.41017d08.svg";